// extracted by mini-css-extract-plugin
module.exports = {"container":"distribute_container__3IKAx"};